import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Icon } from "./Icon";
import { SERVICES } from "../../data/site";

const SPANS = [
  "md:col-span-2 lg:col-span-4",
  "lg:col-span-2",
  "lg:col-span-2",
  "lg:col-span-2",
  "lg:col-span-2",
  "md:col-span-2 lg:col-span-6",
];

const Card = ({ s, i }) => {
  const dark = i === 0 || i === 5;
  const wide = i === 5;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
      className={SPANS[i]}
    >
      <Link
        to={`/servizi/${s.slug}`}
        data-testid={`service-card-${s.slug}`}
        className={`group relative flex h-full min-h-[300px] flex-col overflow-hidden rounded-[22px] border p-7 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1 md:p-9 ${
          dark ? "border-navy bg-navy text-white hover:shadow-[0_24px_60px_rgba(24,49,79,0.35)]" : "border-navy/10 bg-white text-navy hover:border-gold/60 hover:shadow-[0_20px_50px_rgba(24,49,79,0.10)]"
        } ${wide ? "lg:min-h-[240px] lg:flex-row lg:items-end lg:gap-12" : ""}`}
      >
        <span className={`pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full border transition-transform duration-700 group-hover:scale-110 ${dark ? "border-gold/30" : "border-navy/5"}`} />
        <div className={`flex items-start justify-between ${wide ? "lg:flex-col lg:justify-start lg:gap-6" : ""}`}>
          <span className={`flex h-14 w-14 items-center justify-center rounded-2xl border ${dark ? "border-white/15 bg-white/5" : "border-gold/40 bg-mist"}`}>
            <Icon name={s.icon} className={`h-6 w-6 ${dark ? "text-gold" : "text-navy"}`} />
          </span>
          <span className={`text-xs font-semibold tracking-[0.2em] ${dark ? "text-gold" : "text-gold-ink"}`}>0{i + 1}</span>
        </div>
        <div className={`mt-auto pt-10 ${wide ? "lg:flex-1 lg:pt-0" : ""}`}>
          <h3 className={`font-semibold leading-snug ${i === 0 ? "text-2xl md:text-3xl" : "text-xl"}`}>{s.title}</h3>
          <p className={`mt-3 max-w-xl text-sm leading-relaxed ${dark ? "text-white/75" : "text-slate2"}`}>{s.short}</p>
        </div>
        <span className={`mt-6 inline-flex items-center gap-2 text-sm font-semibold ${dark ? "text-gold" : "text-navy"} ${wide ? "lg:mt-0" : ""}`}>
          Scopri il servizio
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </span>
      </Link>
    </motion.div>
  );
};

export const ServicesBento = () => (
  <div data-testid="services-bento" className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-6">
    {SERVICES.map((s, i) => <Card key={s.slug} s={s} i={i} />)}
  </div>
);
